export default [
    "24 24",
  '<path d="M6 9L12 15L18 9" fill="none" class="stroke-over" stroke="var(--ci-primary-color, currentColor)"  stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>\n'
]